import * as AddressFormatter from '@shopify/address/build/ts/index';
import axios from 'axios';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { Setting, Subscription } from '../App';
import { CUSTOMER_API_URL } from '../constants';

export const useAddress = (setting: Setting) => {
  const [subscription, setSubscription] = useState<Subscription>();
  const { id } = useParams<{ id: string }>();
  const reactRouterHistory = useHistory();

  // TODO: locale
  const addressFormatter = new AddressFormatter.default('ja');

  const formRef = useRef(null);
  useEffect(() => {
    axios
      .post(
        `${CUSTOMER_API_URL}?action=getSubscription`,
        {
          subscriptionId: id,
        },
        {
          headers: { Authorization: setting.token },
        },
      )
      .then((response) => {
        setSubscription({
          ...response.data,
          countries: [],
          country: { zones: [] },
          disabled: false,
        });
      });

    window.parent.postMessage({ action: 'subscriptionAddress' }, '*');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      if (!subscription || subscription.countries.length > 0) return;

      // Ignore if subscription's delivery address is blank
      if (!subscription.deliveryCountryCode) return;

      const countries = await addressFormatter.getCountries();
      const country = await addressFormatter.getCountry(subscription.deliveryCountryCode);

      setSubscription({
        ...subscription,
        countries,
        country,
      });
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription]);

  useLayoutEffect(() => {
    // Safari doesn't compute "float: left" height.
    if (!document.querySelector('body')!.scrollHeight) {
      return;
    }

    const height = document.querySelector('body')!.scrollHeight + 100; // buffer;

    setting.resize(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription]);

  const submit = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();

    if (document.querySelectorAll('.invalid').length > 0) {
      return;
    }

    // if (!(formRef as any).current.checkValidity()) {
    //   alert('必須入力箇所が空欄です');
    //   return;
    // }

    setSubscription({
      ...subscription!,
      disabled: true,
    });

    const {
      deliveryAddress1,
      deliveryAddress2,
      deliveryCity,
      deliveryCompany,
      deliveryCountryCode,
      deliveryFirstName,
      deliveryLastName,
      deliveryPhone,
      deliveryProvinceCode,
      deliveryZip,
    } = subscription!;

    try {
      await axios.post(
        `${CUSTOMER_API_URL}?action=updateDeliveryAddress`,
        {
          subscriptionId: id,
          deliveryAddress1,
          deliveryAddress2,
          deliveryCity,
          deliveryCompany,
          deliveryCountryCode,
          deliveryFirstName,
          deliveryLastName,
          deliveryPhone,
          deliveryProvinceCode,
          deliveryZip,
        },
        {
          headers: { Authorization: setting.token },
        },
      );
    } catch (e) {
      // TODO
      alert('不正な入力があります');

      return;
    }

    redirectToShowPage();
  };

  const changeCountry = (countryCode: string) => {
    addressFormatter.getCountry(countryCode).then((country) => {
      setSubscription({
        ...subscription!,
        deliveryCountryCode: countryCode,
        country,
      });
    });
  };

  const redirectToShowPage = () => {
    reactRouterHistory.push(`/`);
    // reactRouterHistory.push(`/subscriptions/${id}`);
  };

  return {
    subscription,
    formRef,
    redirectToShowPage,
    setSubscription,
    changeCountry,
    submit,
  };
};
